import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const Account = {
  Profile: lazy(() => import('./containers/Profile')),
  Company: lazy(() => import('./containers/Company')),
  CompanyTab: lazyNamed(() => import('./containers/Company/tabs'), 'CompanyTab'),
  CompanyUserGroupsList: lazyNamed(() => import('./containers/Company/tabs'), 'UserGroupsList'),
  Users: lazy(() => import('./containers/Users')),
  EditUser: lazyNamed(() => import('./containers/EditUser'), 'EditUser'),
  AdminAccessHistory: lazyNamed(() => import('./containers/AdminAccessHistory'), 'AdminAccessHistory'),
  AdminAccessHistoryRoute: lazyNamed(() => import('./containers/AdminAccessHistory/AdminAccessHistoryRoute'), 'AdminAccessHistoryRoute'),
};

export default Account;
